import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-page-title-banner',
  templateUrl: './page-title-banner.component.html',
  styleUrls: ['./page-title-banner.component.scss'],
})
export class PageTitleBannerComponent {
  @Input() pageTitle: string;
  @Input() backgroundImageStyle: string;
  @Input() overlayGradient: string;
  @Input() showEllipsis: boolean;
  @Output() ellipsisClickEventEmitter = new EventEmitter();

  constructor() {}

  handleEllipsisClickEvent(event: Event) {
    this.ellipsisClickEventEmitter.emit(event);
  }
}
